import { render, staticRenderFns } from "./ProductModalVariant.vue?vue&type=template&id=4d76ad87"
import script from "./ProductModalVariant.vue?vue&type=script&lang=js"
export * from "./ProductModalVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports